module.exports = __webpack_public_path__ + "img/monster.8bf79960.jpg";